<template>
  <base-popup :without-icon="true" ref="popup" class="expanded-popup">
    <template #content>
      <text-area-input
        :title="title"
        v-model:value="content"
        class="expanded-popup__input"
      ></text-area-input>
    </template>
    <template #actions>
      <div class="expanded-popup__actions">
        <no-bg-button
          :label="$t('text-area-expanded.actions.close')"
          class="expanded-popup__actions-item"
          @click="confirm"
        ></no-bg-button>
        <primary-button
          :label="$t('text-area-expanded.actions.add')"
          class="expanded-popup__actions-item"
          @click="confirm"
        ></primary-button>
      </div>
    </template>
  </base-popup>
</template>

<script>
import BasePopup from '@vue-app/components/base/popup/BasePopup.vue'
import NoBgButton from '@vue-app/components/base/button/NoBgButton.vue'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'

export default {
  name: 'TextAreaExpandedPopup',
  components: {
    TextAreaInput: () =>
      import('@vue-app/components/base/input/TextAreaInput.vue'),
    PrimaryButton,
    NoBgButton,
    BasePopup,
  },
  data() {
    return {
      title: '',
      content: '',
    }
  },
  methods: {
    async open(title, content) {
      this.title = title
      this.content = content
      return this.$refs.popup.open()
    },
    confirm() {
      this.$refs.popup.confirm(this.content)
      this.content = ''
      this.title = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.expanded-popup {
  :deep(.popup) {
    padding: 36px 30px;
    width: 80%;
    height: 80%;
    display: flex;
    flex-direction: column;

    .popup__content {
      flex: 1 1 auto;
    }

    .popup__actions {
      flex: 0 0 auto;
    }
  }

  &__actions {
    display: flex;
    justify-content: center;
    gap: 25px;

    &-item {
      padding: 25px;
    }
  }

  &__input {
    height: 100%;
    :deep(.input) {
      .input__el {
        height: 100%;

        .input-wrapper {
          height: 100%;
        }
      }
    }
  }
}
</style>
